/* Rippin Moto redesign. Availability line on the product page.
   Re-renders itself from the section HTML that Savor's variant picker fetches, so the
   line follows the selected variant. Event: shopify:product:select (StandardEvents.productSelect),
   the same event Savor's own product-inventory, product-price and product-sku components use. */
(function () {
  var PRODUCT_SELECT = 'shopify:product:select';

  if (!window.customElements || customElements.get('rm-ships')) return;

  class RmShips extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.onSelect = (event) => this.handleProductSelect(event);
      if (this.section) this.section.addEventListener(PRODUCT_SELECT, this.onSelect);
    }

    disconnectedCallback() {
      if (this.section && this.onSelect) {
        this.section.removeEventListener(PRODUCT_SELECT, this.onSelect);
      }
    }

    handleProductSelect(event) {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      if (!event.promise || typeof event.promise.then !== 'function') return;

      event.promise
        .then((result) => {
          var detail = result && result.detail;
          if (!detail || !detail.html) return;

          if (detail.newProduct && detail.newProduct.id) {
            this.dataset.productId = detail.newProduct.id;
          } else if (detail.productId && detail.productId !== this.dataset.productId) {
            return;
          }

          var next =
            detail.html.querySelector('rm-ships[data-block-id="' + this.dataset.blockId + '"]') ||
            detail.html.querySelector('rm-ships');
          if (!next) return;

          if (next.innerHTML !== this.innerHTML) this.innerHTML = next.innerHTML;
        })
        .catch((error) => {
          if (error && error.name !== 'AbortError') {
            console.warn('[rm-ships] product select promise rejected:', error);
          }
        });
    }
  }

  customElements.define('rm-ships', RmShips);
})();
